
import { defineComponent } from 'vue'
import PostSingle from '@/components/Post/PostSingle.vue'
import ALoader from '@/components/ALoader.vue'
import AButton from '@/components/Forms/AButton.vue'
import { useProfileShow } from '@/composables/user/user'
import useUserPostLoader from '@/composables/post/userPostLoader'

export default defineComponent({
  name: 'ProfilePostList',
  components: {
    AButton,
    PostSingle,
    ALoader,
  },
  props: {
    allowNest: {
      type: Boolean,
      default: true,
    },
    showIp: {
      type: Boolean,
      default: false,
    },
    hideUsername: {
      type: Boolean,
      default: false,
    },
    hideUserBlog: {
      type: Boolean,
      default: false,
    },
    allowAuthorSeenBadge: {
      type: Boolean,
      default: false,
    },
    showAuthorAbove: {
      type: Boolean,
      default: false,
    },
    hideFooter: {
      type: Boolean,
      default: false,
    },
    contentAuthor: {
      type: String,
      default: '',
    },
    showParentAnnotation: {
      type: Boolean,
      default: false,
    },
  },
  async setup() {
    const {
      postTree,
      postList,
      hasNext,
      loadNext,
      totalCount,
      loadedCount,
      loadingList,
      clearListData,
    } = useUserPostLoader()
    const { isShowingCurrentUser } = useProfileShow()

    clearListData()
    await loadNext()

    return {
      totalCount,
      loadedCount,
      loadingList,
      postTree,
      postList,
      hasNext,
      loadNext,
      scrollTo,
      isShowingCurrentUser,
    }
  },
})
